import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

export default function DialogIndexedDB({ openDialogIndexedDB, setOpenDialogIndexedDB, message }) {
    const handleClose = () => {
        setOpenDialogIndexedDB(false);
    };

    return (
        <Dialog open={openDialogIndexedDB} onClose={handleClose}>
            <DialogTitle>{"Problema no Diret\u00f3rio de Dados"}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    );
}